
export const dialogDefault = {
    open: false,
    id: 0,
};

export const catalogsName = 'catalogs';


export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const DIALOG_REGISTER = 'DIALOG_REGISTER';
export const DIALOG_DETAILS = 'DIALOG_DETAILS';
export const DIALOG_RECEIPT = 'DIALOG_RECEIPT';
export const DIALOG_CANCELREGISTER = 'DIALOG_CANCELREGISTER';    
export const DIALOG_CHANGECATEGORY = 'DIALOG_CHANGECATEGORY';
export const DIALOG_CALIFICATION = 'DIALOG_CALIFICATION';
export const DIALOG_CERTIFICATE = 'DIALOG_CERTIFICATE';
export const DIALOG_CLASES = 'DIALOG_CLASES';